import flagsmith from "flagsmith";

class Toggle {
  constructor() {
    this.apiUrl = `${process.env[`REACT_APP_FLAGSMITH_API_HOST`]}/api/v1/`;
    this.connect();
  }

  async connect() {
    const buildMode = process.env.REACT_APP_BUILD_MODE;
    switch (buildMode) {
      case "development":
        this.environmentKey =
          process.env.REACT_APP_FLAGSMITH_ENVIRONMENT_KEY_DEV;
        break;
      case "qa":
        this.environmentKey =
          process.env.REACT_APP_FLAGSMITH_ENVIRONMENT_KEY_QA;
        break;
      case "production":
        this.environmentKey =
          process.env.REACT_APP_FLAGSMITH_ENVIRONMENT_KEY_PROD;
        break;
      case "pre-production":
        this.environmentKey =
          process.env.REACT_APP_FLAGSMITH_ENVIRONMENT_KEY_QA;
        break;
      default:
        this.environmentKey =
          process.env.REACT_APP_FLAGSMITH_ENVIRONMENT_KEY_DEV;
    }

    await flagsmith.init({
      environmentID: this.environmentKey,
      api: this.apiUrl,
    });
  }
  async isEnable(featureName) {
    try {
      return await flagsmith.hasFeature(featureName);
    } catch (error) {
      return false;
    }
  }

  getValue(featureName) {
    try {
      return flagsmith.getValue(featureName);
    } catch (error) {
      return "";
    }
  }
}

const toggle = new Toggle();

export default toggle;
